module.exports = __webpack_public_path__ + "fonts/Gilroy-Semibold.532eab9b.woff";